import { render, staticRenderFns } from "./EventListCardItem.vue?vue&type=template&id=794984a4"
import script from "./EventListCardItem.vue?vue&type=script&lang=js"
export * from "./EventListCardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports